const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const RECAPTCHA_ATTR = 'data-recaptcha-v3';

let loadPromise = null;

function ensureWindow() {
  return typeof window !== 'undefined' ? window : null;
}

function loadRecaptchaScript() {
  const win = ensureWindow();
  if (!win || !SITE_KEY) {
    return Promise.resolve(null);
  }

  if (win.grecaptcha && typeof win.grecaptcha.ready === 'function') {
    return new Promise((resolve) => {
      win.grecaptcha.ready(() => resolve(win.grecaptcha));
    });
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[${RECAPTCHA_ATTR}="${SITE_KEY}"]`);
    const finish = () => {
      if (!win.grecaptcha || typeof win.grecaptcha.ready !== 'function') {
        reject(new Error('reCAPTCHA unavailable'));
        return;
      }
      win.grecaptcha.ready(() => resolve(win.grecaptcha));
    };

    if (existing) {
      if (existing.dataset.loaded === '1') {
        finish();
      } else {
        existing.addEventListener('load', finish, { once: true });
        existing.addEventListener('error', () => reject(new Error('Failed to load reCAPTCHA')), { once: true });
      }
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(SITE_KEY)}`;
    script.async = true;
    script.defer = true;
    script.setAttribute(RECAPTCHA_ATTR, SITE_KEY);
    script.onload = () => {
      script.dataset.loaded = '1';
      finish();
    };
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'));
    document.body.appendChild(script);
  }).finally(() => {
    loadPromise = null;
  });

  return loadPromise;
}

export async function getRecaptchaToken(action) {
  if (!SITE_KEY) {
    return null;
  }
  const grecaptcha = await loadRecaptchaScript();
  if (!grecaptcha || typeof grecaptcha.execute !== 'function') {
    throw new Error('reCAPTCHA not ready');
  }
  const token = await grecaptcha.execute(SITE_KEY, { action });
  if (!token) {
    throw new Error('Failed to obtain reCAPTCHA token');
  }
  return token;
}

export function isRecaptchaConfigured() {
  return Boolean(SITE_KEY);
}

export function ensureRecaptchaReady() {
  if (!SITE_KEY) {
    return Promise.resolve(null);
  }
  return loadRecaptchaScript();
}
